import { useLocalObservable } from 'mobx-react-lite';
import StoreAction from '@store/StoreAction';
import { callLoginUser, callLoginTest } from '@api';
import { runInAction } from 'mobx';

const initialState = {
    loginAccount: 'wanda',
    hintModalVisible: false,
};

const HomeStore = () =>
    useLocalObservable(() => ({
        /* observables */
        ...initialState,
        ...StoreAction(initialState),

        async login(params) {
            const postData = params;
            const res = await callLoginUser(postData);
            const { token, code } = res.data;
            localStorage.setItem('token', token);

            if (code === '903') {
                this.hintModalVisible = true;
            } else {
                this.hintModalVisible = false;
            }
        },
        closeHintModal() {
            console.log('Closing Hint Modal');
            runInAction(() => {
                this.hintModalVisible = false;
            });
        },
        async loginTest() {
            const res = await callLoginTest();
            const { token } = res.data;
            localStorage.setItem('token', token);
        },
        routePage() {
            window.location.href =
                'https://vchat.pscnet.com.tw/mOpenNew/eOpen/#/main/home/general/';
        },
    }));

export default HomeStore;
